import PropTypes from 'prop-types';
import { GECKO_CONSTS } from '../constants';

export const GeckoFieldModel = {
  key: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    GECKO_CONSTS.FIELD_TYPE_ADDRESS,
    GECKO_CONSTS.FIELD_TYPE_CHECKBOX,
    GECKO_CONSTS.FIELD_TYPE_COLOR,
    GECKO_CONSTS.FIELD_TYPE_CUSTOM,
    GECKO_CONSTS.FIELD_TYPE_DATE,
    GECKO_CONSTS.FIELD_TYPE_DISPLAY,
    GECKO_CONSTS.FIELD_TYPE_EMAIL,
    GECKO_CONSTS.FIELD_TYPE_NAME,
    GECKO_CONSTS.FIELD_TYPE_NUMBER,
    GECKO_CONSTS.FIELD_TYPE_PASSWORD,
    GECKO_CONSTS.FIELD_TYPE_RADIO,
    GECKO_CONSTS.FIELD_TYPE_RICH_TEXT,
    GECKO_CONSTS.FIELD_TYPE_SEARCH,
    GECKO_CONSTS.FIELD_TYPE_SELECT,
    GECKO_CONSTS.FIELD_TYPE_SELECT_CREATE_MULTI,
    GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI,
    GECKO_CONSTS.FIELD_TYPE_TELEPHONE,
    GECKO_CONSTS.FIELD_TYPE_TEXT,
    GECKO_CONSTS.FIELD_TYPE_TEXTAREA,
    GECKO_CONSTS.FIELD_TYPE_TITLE,
    GECKO_CONSTS.FIELD_TYPE_TOGGLE,
    GECKO_CONSTS.FIELD_TYPE_URL,
  ]),
  label: PropTypes.string,
  class: PropTypes.string,
  width: PropTypes.string,
  //break: PropTypes.bool,
  required: PropTypes.bool,
  requiredWhen: PropTypes.func,
  disabled: PropTypes.bool,
  disabledWhen: PropTypes.func,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  hideWhen: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      selected: PropTypes.bool,
    })
  ),
  optionValueKey: PropTypes.string,
  optionLabelKey: PropTypes.string,
  optionRenderer: PropTypes.func,
  valueRenderer: PropTypes.func,
  trueValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  falseValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  autoResize: PropTypes.bool, // textarea auto resize
  render: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  errors: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.func,
  ]),
  config: PropTypes.shape({
    placeholder: PropTypes.string,
    rows: PropTypes.number,
    cols: PropTypes.number,
  }),
};

export const GeckoFieldsModel = PropTypes.arrayOf(
  PropTypes.shape(GeckoFieldModel)
);
